import React from "react";
// icons
import YelloInfoDocument from "@frameworks/shared-library/assets/images/features/Markets/Pms/yellow-info-document.svg";
// stylesheet
import "../lead-creation.scss";
var ConfirmRmSelection = function () {
    //
    return (React.createElement("div", { className: "confirm-rm-selection-container" },
        React.createElement("img", { src: YelloInfoDocument, alt: "", className: "info-document" }),
        React.createElement("h4", { className: "title DMSansMedium_20_500 mb-0" }, "Confirm RM Selection!"),
        React.createElement("p", { className: "subtitle DMSanN_13_400 txt_blackOne1" }, "The RM details selected does not belong to client owner, do you still want to proceed")));
};
export default ConfirmRmSelection;
